<template>
  <div class="matchingPage containerLayout">
    <div class="matchingBackground" aria-hidden="true">
      <img
        v-for="icon in matchingBackgroundIcons"
        :key="icon.className"
        :src="icon.src"
        alt=""
        :class="['matchingBackgroundIcon', icon.className]"
      >
    </div>
    <header>
      <img src="@/assets/logo.svg" alt="logo" class="logoPage">
    </header>
    <main>
      <slot/>
    </main>
  </div>
</template>

<script>

import dotIcon from '@/assets/icons/dotIcon.svg';
import spacecraftIcon from '@/assets/icons/spacecraftIcon.svg';
import starIcon from '@/assets/icons/starIcon.svg';

export default {
  name: 'DefaultLayout',
  data() {
    return {
      matchingBackgroundIcons: [
        { src: dotIcon, className: 'matchingBackgroundIcon--topLeftDot' },
        { src: spacecraftIcon, className: 'matchingBackgroundIcon--spacecraft' },
        { src: starIcon, className: 'matchingBackgroundIcon--topRightStar' },
        { src: starIcon, className: 'matchingBackgroundIcon--middleLeftStar' },
        { src: dotIcon, className: 'matchingBackgroundIcon--middleRightDot' },
        { src: starIcon, className: 'matchingBackgroundIcon--bottomLeftStar' },
        { src: dotIcon, className: 'matchingBackgroundIcon--bottomLeftDot' },
        { src: dotIcon, className: 'matchingBackgroundIcon--bottomRightDot' },
      ],
    };
  },
};
</script>

<style>

@font-face {
  font-family: 'DrukFont';
  src: url('@/assets/fonts/Druk-font.otf') format('opentype');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'CorporateFont';
  src: url('@/assets/fonts/CorporateAPro.woff') format("woff");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

body, html {
  font-family: 'DrukFont', sans-serif;
  padding: 0;
  margin: 0;
}

.containerLayout {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #101b52;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding: 2vw;
}

.matchingPage {
  isolation: isolate;
  overflow: hidden;
  padding-top: min(6.1574vw, 133px);
  padding-right: min(4.1204vw, 89px);
  padding-left: min(4.1204vw, 89px);
}

.matchingBackground {
  position: absolute;
  z-index: -1;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.matchingBackground::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle 37.25vw at 92.29% 2.33%, #0090D4 0%, #0090D400 100%),
    radial-gradient(circle 29.40vw at 7.41% 1.41%, #0090D4 0%, #0090D400 100%),
    radial-gradient(circle 36.90vw at 9.86% 97.06%, #0090D4 0%, #0090D400 100%),
    radial-gradient(circle 29.28vw at 97.29% 102.10%, #0090D4 0%, #0090D400 100%),
    radial-gradient(circle 37.01vw at 87.01% 48.95%, #0090D4 0%, #0090D400 100%),
    radial-gradient(circle 26.44vw at 10.19% 58.05%, #0090D4 0%, #0090D400 100%);
  opacity: 0.448;
}

.matchingBackgroundIcon {
  position: absolute;
  display: block;
}

.matchingBackgroundIcon--topLeftDot {
  top: 1.9%;
  left: 5.9%;
  width: 1.14%;
}

.matchingBackgroundIcon--spacecraft {
  top: 8.31%;
  left: 7.83%;
  width: 9.88%;
}

.matchingBackgroundIcon--topRightStar {
  top: 7.83%;
  left: 90.81%;
  width: 5.07%;
  transform: rotate(152deg);
}

.matchingBackgroundIcon--middleLeftStar {
  top: 44.03%;
  left: 3.17%;
  width: 5.16%;
}

.matchingBackgroundIcon--middleRightDot {
  top: 46.03%;
  left: 93.25%;
  width: 1.6%;
}

.matchingBackgroundIcon--bottomLeftStar {
  top: 94.82%;
  left: 3.26%;
  width: 4.2%;
  transform: rotate(46deg);
}

.matchingBackgroundIcon--bottomLeftDot {
  top: 97.94%;
  left: 7.47%;
  width: 0.73%;
}

.matchingBackgroundIcon--bottomRightDot {
  top: 96.77%;
  left: 94.12%;
  width: 1.46%;
}

.matchingPage > header,
.matchingPage > main {
  z-index: 1;
}

header {
  display: flex;
  justify-content: center;
  place-items: center;
}

main {
  flex: 1; /* Allows main to take the remaining space between header and footer */
  position: relative; /* Necessary for positioning the arrow */
}

.logoPage {
  width: 30%;
  padding-top: 22px;
  padding-bottom: 81px;

  @media only screen and (max-width: 1000px) {
    width: 40%;
    padding-top: 20px;
    padding-bottom: 40px;
  }

  @media only screen and (max-width: 550px) {
    width: 45%;
    padding: 20px;
  }
}

.matchingPage .logoPage {
  width: min(29.4444vw, 636px);
  height: min(25.6481vw, 554px);
  padding: 0;
  object-fit: contain;
}

</style>
